import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { isSupportedLanguage } from "@/i18n/config";
import { useAuth } from "@/providers";
import { AppRoutes } from "@/routes";

export const LanguageRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { user, loading } = useAuth();
  const hasRedirected = useRef(false);

  useEffect(() => {
    // Prevent running multiple times
    if (hasRedirected.current) {
      return;
    }

    // Wait for auth to load
    if (loading) {
      return;
    }

    // Extract language from pathname (e.g., "/pl" → "pl")
    const lang = location.pathname.slice(1);

    // Validate language
    if (!isSupportedLanguage(lang)) {
      // Invalid language, redirect to home
      navigate(AppRoutes.ROOT(), { replace: true });
      hasRedirected.current = true;
      return;
    }

    // Set the language
    i18n.changeLanguage(lang);

    // Redirect based on auth state
    if (user) {
      // Logged-in users go to stories
      navigate(AppRoutes.HOME(), { replace: true });
    } else {
      // Non-logged-in users go to home
      navigate(AppRoutes.ROOT(), { replace: true });
    }

    hasRedirected.current = true;
  }, [loading, location.pathname, navigate, i18n, user]);

  // Return null while processing (redirect happens quickly)
  return null;
};
